// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bpRX","colBig":"styles_colBig__U--kA","colSmall":"styles_colSmall__xS5zM"};